import { _freeze, } from '../util/data';
import { _MapLine, } from '../route-view/route-features';
import { _lineSettings, } from '../route-view/route-feature-settings';
const _routeLine = (route, startPoint, endPoint) => {
    const line = _freeze({
        r: () => route,
        sp: () => startPoint,
        ep: () => endPoint,
        ml: () => $mapLine,
        len: () => length,
        set: (newStartPoint, newEndPoint) => {
            if (newStartPoint) {
                startPoint = newStartPoint;
            }
            if (newEndPoint) {
                endPoint = newEndPoint;
            }
            const startPosition = startPoint.m().getLatLng(), endPosition = endPoint.m().getLatLng();
            $mapLine.setLatLngs([startPosition, endPosition]);
            length = startPosition.distanceTo(endPosition);
            return line;
        },
    }), linePaneId = route.p().lid(), settings = Object.assign(Object.assign({}, _lineSettings), { pane: linePaneId }), $mapLine = new _MapLine(_initialLineLatLngs, settings, line);
    let length = 0;
    line.set(startPoint, endPoint);
    return line;
}, _initialLineLatLngs = [];
export { _routeLine, };
